function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

const EXTRA_WRITE_TOOLS = new Set([
  "remember_fact",
  "create_organization",
  "execute_now",
  "upload_file_as_template",
  "attach_file_to_lead",
  "attach_file_to_employee",
  "roles_create_preset",
  "roles_update_preset",
  "roles_delete_preset",
  "roles_update_member_rights",
  "roles_invite_member",
]);

export function toolNameFromChatPart(part: unknown): string | null {
  if (!isRecord(part)) return null;
  if (typeof part.toolName === "string" && part.toolName.trim()) return part.toolName.trim();
  const type = String(part.type ?? "");
  if (type.startsWith("tool-")) {
    const name = type.slice("tool-".length).trim();
    return name || null;
  }
  return null;
}

export function isAiWriteToolPart(part: unknown): boolean {
  const name = toolNameFromChatPart(part);
  if (!name) return false;
  return name.startsWith("request_") || EXTRA_WRITE_TOOLS.has(name);
}

function isUndoneWritePart(part: unknown): boolean {
  return isRecord(part) && typeof part.undoneAt === "string" && Boolean(part.undoneAt.trim());
}

export function assistantPartsHaveWrites(parts: unknown[] | undefined): boolean {
  return Array.isArray(parts) && parts.some(isAiWriteToolPart);
}

export function assistantPartsHavePendingWrites(parts: unknown[] | undefined): boolean {
  return Array.isArray(parts) && parts.some((part) => isAiWriteToolPart(part) && !isUndoneWritePart(part));
}

export function lastWriteAssistantMessageId(
  messages: Array<{ id: string; role: string; requestId?: string | null; assistantParts?: unknown[] }>,
): string | null {
  for (let i = messages.length - 1; i >= 0; i--) {
    const message = messages[i];
    if (message.role !== "assistant") continue;
    if (typeof message.requestId === "string" && message.requestId.startsWith("undo_")) continue;
    if (assistantPartsHavePendingWrites(message.assistantParts)) return message.id;
  }
  return null;
}
